// extracted by mini-css-extract-plugin
export default {"widget-date-cell_edit":"styles_widget-date-cell_edit__1uITz"};